"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgApple(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), React.createElement("g", {
    fillRule: "evenodd",
    fill: "inherit"
  }, React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M12.238 5.631c1.069 0 2.409-.72 3.206-1.678.723-.87 1.25-2.083 1.25-3.297 0-.165-.015-.33-.045-.465-1.19.045-2.62.794-3.478 1.798-.677.765-1.294 1.964-1.294 3.193 0 .18.03.36.045.42.075.014.195.03.316.03zM8.474 23.765c1.46 0 2.108-.974 3.93-.974 1.851 0 2.258.944 3.883.944 1.596 0 2.665-1.469 3.674-2.908 1.129-1.648 1.595-3.267 1.625-3.342-.105-.03-3.16-1.273-3.16-4.765 0-3.028 2.408-4.391 2.543-4.496-1.595-2.278-4.02-2.338-4.682-2.338-1.791 0-3.251 1.079-4.17 1.079-.993 0-2.303-1.02-3.853-1.02-2.951 0-5.947 2.429-5.947 7.015 0 2.847 1.114 5.86 2.484 7.807C5.975 22.416 7 23.765 8.474 23.765z",
    fillRule: "nonzero"
  })));
}

var _default = SvgApple;
exports.default = _default;